import React from "react";
import { motion } from "framer-motion";
import { FaEnvelope, FaUsers } from "react-icons/fa";

const Career = () => {
  return (
    <section className="bg-white py-20">

      <div className="max-w-[1450px] mx-auto px-6">

        {/* Heading */}

        <div className="text-center mb-16">

          <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">
            Cambridge International School
          </p>

          <h1 className="text-5xl md:text-6xl font-black text-[#07294d]">
            Careers
          </h1>

          <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

          <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-9">
            Join our team of passionate educators and professionals.
            We welcome dedicated individuals who believe in academic
            excellence and holistic education.
          </p>

        </div>

        <div className="grid lg:grid-cols-5 gap-12">

          {/* LEFT PANEL */}

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
            className="lg:col-span-2"
          >

            <div className="bg-[#f8fafc] rounded-[28px] p-8 border border-gray-100 shadow-lg">

              <div className="w-16 h-16 rounded-2xl bg-[#07294d] text-white flex items-center justify-center text-2xl mb-6">

                <FaUsers />

              </div>

              <h2 className="text-3xl font-black text-[#07294d] mb-6">

                Join Our Team

              </h2>

              <p className="text-gray-600 leading-8 mb-6">

                We are always looking for talented, passionate and
                dedicated professionals who can contribute to the
                growth of our students and institution.

              </p>

              <div className="flex gap-4">

                <FaEnvelope className="text-[#d4af37] text-xl mt-1 flex-shrink-0" />

                <p className="text-gray-600 leading-8">

                  You are welcome to send your resume in soft copy.
                  Kindly include your educational qualifications,
                  work experience, previous employer, current and
                  expected salary along with the position you are
                  applying for.

                </p>

              </div>

            </div>

          </motion.div>

          {/* RIGHT PANEL */}

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
            className="lg:col-span-3 bg-[#f8fafc] rounded-[28px] p-8 border border-gray-100 shadow-lg"
          >

            <h2 className="text-3xl font-black text-[#07294d] mb-8">

              Career Application Form

            </h2>

            <form className="grid md:grid-cols-2 gap-6">
                              {/* Functional Area */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Functional Area
                </label>

                <select className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:border-[#07294d]">
                  <option>Select Functional Area</option>
                  <option>Teaching</option>
                  <option>Administration</option>
                  <option>Accounts</option>
                  <option>Transport</option>
                  <option>Library</option>
                  <option>Sports</option>
                  <option>IT Department</option>
                </select>
              </div>

              {/* First Name */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  First Name
                </label>

                <input
                  type="text"
                  placeholder="First Name"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* Last Name */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Last Name
                </label>

                <input
                  type="text"
                  placeholder="Last Name"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* DOB */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Date of Birth
                </label>

                <input
                  type="date"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* Marital Status */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Marital Status
                </label>

                <select className="w-full border border-gray-300 rounded-xl px-4 py-3">
                  <option>Select</option>
                  <option>Single</option>
                  <option>Married</option>
                </select>
              </div>

              {/* Gender */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Gender
                </label>

                <select className="w-full border border-gray-300 rounded-xl px-4 py-3">
                  <option>Select</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
              </div>

              {/* Address */}

              <div className="md:col-span-2">

                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Current Address
                </label>

                <textarea
                  rows="3"
                  placeholder="Current Address"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                ></textarea>

              </div>

              {/* Location */}

              <div>

                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Current Location
                </label>

                <input
                  type="text"
                  placeholder="Current Location"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />

              </div>

              {/* Pin Code */}

              <div>

                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Pin Code
                </label>

                <input
                  type="text"
                  placeholder="Pin Code"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />

              </div>

              {/* Mobile */}

              <div>

                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Mobile Number
                </label>

                <input
                  type="tel"
                  placeholder="Mobile Number"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />

              </div>

              {/* Email */}

              <div>

                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Email Address
                </label>

                <input
                  type="email"
                  placeholder="Email Address"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />

              </div>
                            {/* Current Designation */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Current Designation
                </label>

                <input
                  type="text"
                  placeholder="Current Designation"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* Current Employer */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Current Employer
                </label>

                <input
                  type="text"
                  placeholder="Current Employer"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* Salary */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Current Gross Salary
                </label>

                <input
                  type="text"
                  placeholder="Current Gross Salary"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* Skills */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Key Skills
                </label>

                <input
                  type="text"
                  placeholder="Key Skills"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* Experience */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Experience (Years)
                </label>

                <select className="w-full border border-gray-300 rounded-xl px-4 py-3">
                  <option>Years</option>
                  {[...Array(31)].map((_, i) => (
                    <option key={i}>{i}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Experience (Months)
                </label>

                <select className="w-full border border-gray-300 rounded-xl px-4 py-3">
                  <option>Months</option>
                  {[...Array(12)].map((_, i) => (
                    <option key={i}>{i + 1}</option>
                  ))}
                </select>
              </div>

              {/* Qualification */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Qualification
                </label>

                <select className="w-full border border-gray-300 rounded-xl px-4 py-3">
                  <option>Select Qualification</option>
                  <option>Graduate</option>
                  <option>Post Graduate</option>
                  <option>B.Ed</option>
                  <option>M.Ed</option>
                  <option>Ph.D.</option>
                  <option>Other</option>
                </select>
              </div>

              {/* Resume */}

              <div>
                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Upload Resume
                </label>

                <input
                  type="file"
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                />
              </div>

              {/* Description */}

              <div className="md:col-span-2">

                <label className="block text-sm font-semibold text-[#07294d] mb-2">
                  Short Description
                </label>

                <textarea
                  rows="5"
                  placeholder="Write a short description..."
                  className="w-full border border-gray-300 rounded-xl px-4 py-3"
                ></textarea>

              </div>

              {/* Submit */}

              <div className="md:col-span-2 text-center pt-4">

                <button
                  type="submit"
                  className="bg-[#07294d] hover:bg-[#0b3d69] text-white px-10 py-4 rounded-full font-semibold transition"
                >
                  Submit Application
                </button>

              </div>

            </form>

          </motion.div>

        </div>

      </div>

    </section>
  );
};

export default Career;